module.exports = __webpack_public_path__ + "static/media/village.7da27ed6.jpeg";